import { createContext, useState } from "react";

export const ConfirmDeleteModalContext = createContext({
  openConfirmDeleteModal: false,
  setOpenConfirmDeleteModal: () => false,
});

export const ConfirmDeleteModalProvider = ({ children }) => {
  const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
  const value = { openConfirmDeleteModal, setOpenConfirmDeleteModal };
  return (
    <ConfirmDeleteModalContext.Provider value={value}>
      {children}
    </ConfirmDeleteModalContext.Provider>
  );
};
